import React, { useEffect, useState } from "react";
import Sidebar from "../Side/Sidebar";
import Topbar from "../Side/Topbar";
import AdminSidebar from "../Side/AdminSidebar";
import AdunitTable from "../Dashboards/AdunitTable";
import { useAuth } from '../Auth/AuthContext';
import AdscodeTable from "../Dashboards/AdscodeTable";

const Adscode = () => {
   const Auth = useAuth();
    const admin = Auth.authState.roles === "Admin";

    return (
        <div className="min-h-screen flex flex-col md:flex-row">
            {/* Sidebar */}
            {admin ? <AdminSidebar /> : <Sidebar />}

            {/* Main Content */}
            <div className="flex-1 bg-gray-100">
                <div className="flex-1 flex flex-col">
                    <Topbar />

                    {/* Main Content */}
                    <main className="pt-[160px] px-4">
                        <div className="mt-6">
                            <AdscodeTable />
                        </div>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default Adscode;
